import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='footer'>
      <div className='container-fluid'>

      <div className='footer-left'>
        {/* Same company, year and links as the login footer (layouts/auth.js). */}
        <Link to="/privacy-policy" className='footer-links'>Privacy Policy</Link>
        <Link to="/terms" className='footer-links'>Terms &amp; Conditions</Link>
      </div>

      <div className='footer-right'>
        <span className='copyright'>&copy; {new Date().getFullYear()} ADM CPA P.C.</span>
      </div>
      </div>
    </div>
  )
}

export default Footer